import React from "react";
import Box from "@mui/material/Box";
import ZendeskLink from "commonComponents/ZendeskLink";

const sx = {
  root: {
    textAlign: "center",
    width: "100%"
  }
};

export default function Footer() {
  return (
    <Box sx={sx.root}>
      <ZendeskLink />
    </Box>
  );
}
